import { render } from "./Studentcount.vue?vue&type=template&id=314df1a5"
import script from "./Studentcount.vue?vue&type=script&lang=js"
export * from "./Studentcount.vue?vue&type=script&lang=js"

import "./Studentcount.vue?vue&type=style&index=0&id=314df1a5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__